<div class="card card-table tabela">
  <div class="card-body">
    <div>
      <header class="header">
        <h2 class="card-title">Últimas Denúncias</h2>
      </header>
      <div class="see-all">
        <a
          id="btn-all-complaints"
          [routerLink]="['ocurrences']"
          class="btn-link"
          routerLinkActive="router-link-active"
        >
          <span class="see-all-content">Ver Todos</span>
          <span class="material-icons">arrow_right</span>
        </a>
      </div>
    </div>
    <!--Table-->
    <div class="table-wrapper">
      <table mat-table [dataSource]="dataSourceDenounces">
        <!-- ID Column -->
        <ng-container matColumnDef="id">
          <th mat-header-cell *matHeaderCellDef>ID da Denúncia</th>
          <td class="id-c" mat-cell *matCellDef="let element">
            <div
              [routerLink]="['ocurrences-details', element._id]"
              routerLinkActive="active"
            >
              {{ element._id }}
            </div>
          </td>
        </ng-container>
        <!-- Action Column -->
        <ng-container matColumnDef="action">
          <th mat-header-cell *matHeaderCellDef>Ações</th>
          <td
            class="action-c"
            mat-cell
            *matCellDef="let element; let i = index"
          >
            <div class="d-flex align-items-center">
              <button
                id="{{ 'btn-see-' + i }}"
                [routerLink]="['ocurrences-details', element._id]"
                routerLinkActive="active"
                mat-icon-button
                aria-label="Veja detalhes da ocorrência"
              >
                <mat-icon>remove_red_eye</mat-icon>
              </button>
              <!-- Action Column
              <button id="{{'btn-delete-' + i}}" *ngIf="su || user.role=='ADMIN'" mat-icon-button
                (click)="deleteComplaintFunc(element)" aria-label="Settings Icon">
                <mat-icon>delete</mat-icon>
              </button>
              -->
            </div>
          </td>
        </ng-container>
        <!-- Date Created Column -->
        <ng-container matColumnDef="date_created">
          <th mat-header-cell *matHeaderCellDef>Denunciado</th>
          <td class="created-at" mat-cell *matCellDef="let element">
            {{ element.created_at | date : "dd/MM/yyyy" : "PST" }}
          </td>
        </ng-container>
        <!-- Date Column -->
        <ng-container matColumnDef="date">
          <th mat-header-cell *matHeaderCellDef>Ocorrido</th>
          <td class="date-time" mat-cell *matCellDef="let element">
            {{ element.datetime | date : "dd/MM/yyyy" : "PST" }}
          </td>
        </ng-container>
        <!-- Status Column -->
        <ng-container matColumnDef="status">
          <th mat-header-cell *matHeaderCellDef>Tipo</th>
          <td mat-cell *matCellDef="let element">
            <span class="">
              {{ utilsService.transformType(element.type) }}</span
            >
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumnsDenounces"></tr>
        <tr
          mat-row
          *matRowDef="let row; columns: displayedColumnsDenounces"
        ></tr>
      </table>
    </div>
    <div class="d-md-flex align-items-center justify-content-end">
      <mat-paginator [pageSizeOptions]="[10, 15, 30]" showFirstLastButtons>
      </mat-paginator>
    </div>
  </div>
</div>

<div class="card card-table tabela-responsiva">
  <div class="card-body">
    <div>
      <header
        class="header"
        style="
          padding-left: 8px !important;
          padding-right: 8px !important;
          padding-bottom: 16px !important;
        "
      >
        <h2 class="card-title">Últimas Denúncias</h2>
      </header>
      <div class="see-all">
        <a
          id="btn-all-complaints"
          [routerLink]="['ocurrences']"
          class="btn-link"
          routerLinkActive="router-link-active"
        >
          <span class="see-all-content">Ver Todos</span>
          <span class="material-icons">arrow_right</span>
        </a>
      </div>
    </div>

    <div class="conteudo" *ngFor="let denuncia of listaDenuncias[pagina]">
      <div>
        <div
          class="resposta-denuncia"
          style="
            padding-right: 8px;
            display: flex;
            justify-content: space-between;
          "
        >
          <div>
            <h2 class="denuncia-title">ID da Denúncia</h2>
            <p>{{ denuncia._id }}</p>
          </div>
          <div [routerLink]="['ocurrences-details', denuncia._id]">
            <img src="assets/icons/seeDetails.svg" alt="" />
          </div>
        </div>
      </div>
      <div
        style="
          display: flex;
          justify-content: space-between;
          padding-right: 8px;
          padding-left: 8px;
        "
      >
        <div>
          <h2 class="denuncia-title">Denunciado</h2>
          <p>{{ denuncia.created_at | date : "dd/MM/yyyy" : "PST" }}</p>
        </div>
        <div>
          <h2 class="denuncia-title">Ocorrido</h2>
          <p>{{ denuncia.datetime | date : "dd/MM/yyyy" : "PST" }}</p>
        </div>
        <div>
          <h2 class="denuncia-title">Tipo</h2>
          <p>{{ utilsService.transformType(denuncia.type) }}</p>
        </div>
      </div>
    </div>
    <div class="d-md-flex align-items-center justify-content-end">
      <mat-paginator
        [length]="this.listaDenuncias.length"
        (page)="change($event)"
        [pageSizeOptions]="[5]"
        showFirstLastButtons
      >
      </mat-paginator>
    </div>
  </div>
</div>
